import React from 'react';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';

function withTranslated(Component) {
  return class TranslatorWrapper extends React.Component {
    static contextTypes = {
      language: PropTypes.string.isRequired,
      translations: PropTypes.object.isRequired,
      getTranslation: PropTypes.func.isRequired,
    }

    selector = createSelector(
      ({ text }) => text,
      ({ data }) => data,
      ({ language }) => language,
      (text, data) => {
        return this.context.getTranslation(text, data);
      }
    );

    transProcess = (text, data) => {
      const { language } = this.context;      
      return this.selector({ text, data, language });
    }

    render() {
      return <Component {...this.props} t={this.transProcess} />;
    }
  }
}

export default withTranslated;


// WEBPACK FOOTER //
// ./src/components/HOC/withTranslated.jsx